import React from 'react';
import { usePreviewMode } from '../../contexts/PreviewModeContext';
import './PreviewBanner.css';

export default function PreviewBanner() {
    const isPreview = usePreviewMode();
    if (!isPreview) return null;

    return (
        <div className="preview-banner">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                <circle cx="12" cy="12" r="3"/>
            </svg>
            <span>
                <strong>Admin Preview Mode</strong> — Viewing customer site as guest. Cart, checkout, account &amp; chat are disabled.
            </span>
        </div>
    );
}